export default {
  bmiCalculator: {
    actions: {
      calculateBMI: 'Bereken BMI',
      continue: 'Doorgaan',
    },
    breadcrumbLink: 'Selecteer afspraaktype',
    header: 'We hebben meer informatie nodig',
    subheader:
      'Om een afspraak te maken, moeten we jouw Body Mass Index (BMI) berekenen. Vul alstublieft het volgende in:',
  },
  bmiHigh: {
    actions: {
      callUs: 'Bel ons',
    },
    availableHours: {
      friday: 'Vrijdag 8:00–17:00',
      mondayToThursday: 'Maandag–Donderdag 8:00–18:00',
      title: 'Beschikbare uren',
    },
    breadcrumbLink: 'Terug',
    contactInfo:
      'Wil je toch graag meer weten over de mogelijkheden? Neem dan gerust contact op met ons informatiecentrum via',
    header: 'We kunnen jouw gewenste afspraak helaas niet inplannen.',
    specialistInfo:
      'Onze specialisten denken graag met je mee en informeren je over de eventuele vervolgstappen die passend zijn bij jouw situatie.',
    thresholdInfo:
      'Indien je een BMI hoger dan {{bmiThreshold}} hebt, kom je op dit moment nog niet in aanmerking voor het direct online plannen van een eerste consult. Dit heeft te maken met je gezondheidssituatie en de extra zorgvuldigheid die daarbij nodig is.',
    yourBmi: 'Jouw BMI is:',
  },
  confirmBooking: {
    actions: {
      changeAppointment: 'Afspraak wijzigen',
      confirmBooking: 'Afspraak bevestigen',
    },
    breadcrumbLink: 'Kies datum en tijd',
    caption:
      'Let op: Aan een consult zijn € 30 (huid) of € 50,- (injectables en plastische chirurgie) consultkosten verbonden. Deze worden in mindering gebracht op de uiteindelijke prijs van je behandeling, wanneer je deze binnen een jaar ondergaat.',
    header: 'Bevestig details',
    selectDifferentTimeslot: 'Kies een ander tijdstip',
  },
  errorScreen: {
    messages: {
      canNotAcceptPatientsUnder18:
        'Velthuis Kliniek accepteert geen patiënten jonger dan 18 jaar voor de meeste behandelingen. Neem contact met ons op via 088-7785201 als je vragen hebt.',
      network: 'Netwerkfout. Check je verbinding en probeer het opnieuw.',
    },
  },
  healthWarning: {
    acknowledgementLabel:
      'Ik begrijp dat mijn gezondheidssituatie invloed kan hebben op het behandeladvies van de arts.',
    actions: {
      continue: 'Doorgaan',
    },
    breadcrumbLink: 'Terug',
    conditions: {
      epilepsy: 'epilepsie',
      heartProblems: 'hartproblemen',
      lungProblems: 'longproblemen',
      neurologicalIssues: 'neurologische klachten (hersenen)',
      smoking: 'of rook je?',
    },
    description:
      'Dan ben je van harte welkom voor een consult. Onze arts bekijkt tijdens het gesprek zorgvuldig wat voor jou de meest geschikte en veilige behandelroute is. Het is mogelijk dat er op basis van je gezondheidssituatie een aangepast behandeltraject wordt geadviseerd.',
    header: 'Heb je het afgelopen jaar last gehad van:',
    subheader: 'Gezondheidsgegevens',
  },
  patientDetails: {
    actions: {
      continue: 'Doorgaan',
    },
    description: 'Vul de volgende gegevens in om jouw afspraak te bevestigen',
    header: 'Vul jouw gegevens in',
  },
  proposedAppointment: {
    actions: {
      confirmAppointment: 'Afspraak bevestigen',
      selectTimeSlot: 'Kies een andere tijd',
    },
    description:
      'Als de volgende voorgestelde afspraak niet uitkomt, kies dan een andere tijd.',
    error:
      'Er is een fout opgetreden bij het ophalen van de beschikbare tijden.',
    header: 'Voorgestelde afspraak',
  },
  selectAppointment: {
    actions: {
      continue: 'Doorgaan',
    },
    appointmentType: 'Afspraaktype',
    breadcrumbLink: 'Kies categorie',
    header: 'Welke afspraak wil je maken?',
  },
  selectCategory: {
    actions: {
      continue: 'Doorgaan',
    },
    canNotAcceptPatientsUnder18:
      'Velthuis Kliniek accepteert geen patiënten jonger dan 18 jaar voor de meeste behandelingen. Neem contact met ons op via 088-7785201 als je vragen hebt.',
    dateOfBirth: 'Geboortedatum',
    fillDate: 'Vul je geboortedatum in',
    header: 'Kies categorie',
    invalidDateOfBirth: 'Voer een geldige geboortedatum in',
    learnMoreAboutDateOfBirth:
      'Lees <0>hier</0> waarom we je geboortedatum vragen',
    parentalConsentCheckbox:
      'Ik bevestig dat ik toestemming heb van mijn ouders of voogd',
    subheader: 'Waarvoor wil je een afspraak inplannen?',
  },
  selectClinic: {
    actions: {
      selectTimeSlot: 'Kies tijd',
    },
    breadcrumbLink: 'Terug',
    closestClinic: 'Kies de kliniek die het dichtst bij je in de buurt is',
    header: 'Kies kliniek',
    selectDoctor: 'Kies een behandelaar',
    showingDistance: 'Resultaten gesorteerd op afstand',
    subheader: 'Zoek klinieken',
    switchLabel:
      'Zoek de kliniek het dichtst bij je in de buurt. Dit kun je later nog aanpassen.',
    zipCodeInvalid: '*Ongeldige postcode',
    zipCodeLabel: 'Postcode',
  },
  selectDateTime: {
    actions: {
      reviewBooking: 'Boeking controleren',
      showAllClinicianSlots: 'Toon alle tijdsloten voor zorgverleners',
    },
    breadcrumbLink: 'Selecteer arts',
    description:
      'De beschikbaarheid van tijdsloten wordt in realtime bijgewerkt en wordt na selectie bevestigd.',
    dropdownDoctors: {
      all: 'Toon alles',
      label: 'Kies een arts',
    },
    header: 'Kies datum en tijd',
    noSlots: 'Geen beschikbare tijdsloten voor de geselecteerde locatie',
  },
  selectDoctor: {
    actions: {
      continue: 'Doorgaan',
      skipThisStep: 'Sla deze stap over',
    },
    breadcrumbLink: 'Kies kliniek',
    header: 'Kies een behandelaar',
    noDoctorsFound:
      'Geen beschikbare zorgverleners voor de geselecteerde locatie',
  },
}
